import Badge from './Badge';

export { Props, Status } from './Badge';
export default Badge;
